import { __extends } from "tslib";
import config from '../config';
import Flow from './Flow';
var ChooseType = /*@__PURE__*/ (function (_super) {
    __extends(ChooseType, _super);
    function ChooseType() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.init = function () {
            _this.setRoamingStepperItem(config.appointman.flow.CHOOSE_TYPE);
            _this.options = [];
            _this.mappedOptions = {};
            if (_this.getState().APPOINTMAN_TYPES) {
                _this.types = _this.getState().APPOINTMAN_TYPES;
                _this.createTypeOptions();
            }
            if (_this.getState().CURRENT_FLOW === config.appointman.flow.CHOOSE_TYPE) {
                _this.activate();
            }
            _this.registerEventListeners();
            _this.flow = _this.getState().CURRENT_FLOW;
            if (_this.getState().apmType) {
                if (_this.getState().apmType.length > 0) {
                    _this.activeTypeLabel = config.appointman.msg.CHOOSE_TYPE_API[_this.getState().apmType + "_LABEL"];
                    _this.getItem().setComplete(true);
                    _this.getItem().setLabel(_this.buildPreviewLabel());
                }
            }
        };
        _this.registerEventListeners = function () {
            _this.getItem().onChangeRequest(function () {
                _this.setState({
                    CURRENT_FLOW: config.appointman.flow.CHOOSE_TYPE
                });
                _this.getItem().setComplete(false);
                _this.getItem().setLabel(_this.buildActiveLabel());
            });
        };
        _this.createTypeOptions = function () {
            console.log('rendering');
            var options = _this.types;
            var type;
            var unavailableApmTypes = false;
            jQuery(_this.getElement()).find('[data-appointment-types]').html('');
            for (type in options) {
                if (!options.hasOwnProperty(type)) {
                    continue;
                }
                if (_this.getState().availableApmTypes.indexOf(type.toString()) < 0) {
                    unavailableApmTypes = true;
                    continue;
                }
                var optionHtml = ChooseType.TYPE_OPTION_HTML;
                if (_this.getState().apmType === type) {
                    console.log('yes');
                    optionHtml = ChooseType.ACTIVE_TYPE_OPTION_HTML;
                }
                var labelType = type.toString() + "_LABEL";
                var label = config.appointman.msg.CHOOSE_TYPE_API[labelType.toString()];
                var description = config.appointman.msg.CHOOSE_TYPE_API[type.toString() + "_DESCRIPTION"];
                optionHtml = _this.replaceAll(optionHtml, '%id', type);
                optionHtml = _this.replaceAll(optionHtml, '%label', label);
                optionHtml = _this.replaceAll(optionHtml, '%description', description);
                var optionElement = jQuery(optionHtml);
                jQuery(_this.getElement()).find('[data-appointment-types]').append(optionElement);
                _this.options.push(optionElement);
                _this.mappedOptions[type] = optionElement;
            }
            if (unavailableApmTypes) {
                jQuery(_this.getElement()).find('.apttype-unavailable').addClass('shown');
            }
            else {
                jQuery(_this.getElement()).find('.apttype-unavailable').removeClass('shown');
            }
            _this.registerOptionListener();
        };
        _this.registerOptionListener = function () {
            var that = _this;
            jQuery(_this.getElement()).find('[name=apmType]').on('change', function () {
                var value = $(this).val();
                that.activeTypeLabel = config.appointman.msg.CHOOSE_TYPE_API[value.toString() + "_LABEL"];
                that.setState({
                    apmType: value
                });
            });
        };
        return _this;
    }
    ChooseType.prototype.onStateChange = function () {
        var state = this.getState();
        if (state.apmType) {
            this.enableNextButton();
        }
        else {
            this.disableNextButton();
        }
        if (state.APPOINTMAN_TYPES !== this.types) {
            this.types = state.APPOINTMAN_TYPES;
            this.createTypeOptions();
        }
        if (state.CURRENT_FLOW === config.appointman.flow.CHOOSE_TYPE) {
            if (this.flow !== state.CURRENT_FLOW) {
                this.flow = state.CURRENT_FLOW;
                this.activate();
            }
        }
        else {
            this.flow = state.CURRENT_FLOW;
        }
    };
    ChooseType.prototype.onNextRequest = function () {
        this.setState({
            CURRENT_FLOW: config.appointman.flow.CHOOSE_DATE
        });
        this.getItem().setComplete(true);
        this.getItem().setLabel(this.buildPreviewLabel());
    };
    ChooseType.prototype.replaceAll = function (str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    };
    ChooseType.prototype.buildPreviewLabel = function () {
        var html = ChooseType.PREVIEW_LABEL_HTML;
        var value = this.activeTypeLabel;
        html = html.replace('%s', value);
        return html;
    };
    ChooseType.prototype.buildActiveLabel = function () {
        var html = ChooseType.ACTIVE_LABEL_HTML;
        return html;
    };
    ChooseType.TYPE_OPTION_HTML = "<div class=\"fm-data\">\n        <input id=\"radio-%id\" type=\"radio\" name=\"apmType\" value=\"%id\">\n        <label for=\"radio-%id\">\n            <strong>%label</strong><br>\n            %description\n        </label>\n    </div>";
    ChooseType.ACTIVE_TYPE_OPTION_HTML = "<div class=\"fm-data\">\n        <input id=\"radio-%id\" type=\"radio\" name=\"apmType\" value=\"%id\" checked=\"checked\">\n        <label for=\"radio-%id\" class=\"checked\">\n            <strong>%label</strong><br>\n            %description\n        </label>\n    </div>";
    ChooseType.PREVIEW_LABEL_HTML = config.appointman.msg.CHOOSE_TYPE_PREVIEW;
    ChooseType.ACTIVE_LABEL_HTML = config.appointman.msg.CHOOSE_TYPE_ACTIVE;
    return ChooseType;
}(Flow));
export default ChooseType;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/flow/ChooseType.ts
// module id = null
// module chunks = 